module.exports = __webpack_public_path__ + "img/logo1.ceda2d76.png";